export default "__VITE_PUBLIC_ASSET__3e232f5e__"